/**
 * CarsTab.jsx — 렌트카 list + CRUD (Phase 2 조회 + Phase 3-C 수정/추가/삭제, 2026-04-30)
 */
import React, { useState } from 'react';
import { apiClient } from '../../../api/apiClient';
import CarModal from './CarModal';
import {
  mobileActionRow,
  mobileAddButton,
  mobileAmount,
  mobileCard,
  mobileCardHeader,
  mobileCardList,
  mobileCardTitle,
  mobileDeleteButton,
  mobileEditButton,
  mobileEmpty,
  mobileInfoGrid,
  mobileInfoItem,
  mobileInfoLabel,
  mobileInfoValue,
  mobileSubText,
  mobileTabWrap,
  mobileTitleText,
  mobileTopActionRow,
} from './ReservationDetail.mobileStyles';

const fmt = (n) => (n == null ? '-' : Number(n).toLocaleString('ko-KR'));
const fmtDt = (d) => {
  if (!d) return '-';
  const s = String(d);
  return s.replace('T', ' ').slice(0, 16);
};

export default function CarsTab({ rows = [], travelCode, onChanged, isMobile = false }) {
  const [modalRow, setModalRow] = useState(undefined);

  async function handleDelete(row) {
    if (!window.confirm(`렌트카 #${row.id} 삭제하시겠습니까?`)) return;
    const r = await apiClient.delete(`/api/admin/car-rentals/${row.id}`);
    if (r.ok && r.data?.success) onChanged && onChanged();
    else alert(r.data?.message || '삭제 실패');
  }

  return (
    <div style={isMobile ? mobileTabWrap : { display: 'grid', gap: 8 }}>
      <div style={isMobile ? mobileTopActionRow : { display: 'flex', justifyContent: 'flex-end' }}>
        <button onClick={() => setModalRow(null)} style={isMobile ? mobileAddButton : addBtn}>+ 렌트카 추가</button>
      </div>
      {rows.length === 0 ? (
        <div style={isMobile ? mobileEmpty : emptyStyle}>렌트카 예약 없음</div>
      ) : isMobile ? (
        <div style={mobileCardList}>
          {rows.map((r, index) => (
            <div key={r.id} style={mobileCard}>
              <div style={mobileCardHeader}>
                <div style={mobileCardTitle}>
                  <span style={mobileTitleText}>렌트 #{index + 1}</span>
                  <span style={mobileSubText}>{r.rental_company || r.car_model || '-'}</span>
                </div>
                <span style={mobileAmount()}>{fmt(r.total_cost)}</span>
              </div>
              <div style={mobileInfoGrid}>
                <Info label="업체" value={r.rental_company || '-'} />
                <Info label="차종" value={r.car_model || '-'} />
                <Info label="인수지" value={r.pickup_location || '-'} />
                <Info label="반납지" value={r.return_location || '-'} />
                <Info label="인수일시" value={fmtDt(r.pickup_at)} />
                <Info label="반납일시" value={fmtDt(r.return_at)} />
                <Info label="운전자" value={r.driver_name || '-'} />
                <Info label="보험" value={r.insurance_type || '-'} />
              </div>
              <div style={mobileActionRow}>
                <button onClick={() => setModalRow(r)} style={mobileEditButton}>수정</button>
                <button onClick={() => handleDelete(r)} style={mobileDeleteButton}>삭제</button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
            <thead style={{ background: 'var(--bg)', color: 'var(--text-muted)' }}>
              <tr>
                <th style={th}>업체</th>
                <th style={th}>차종</th>
                <th style={th}>인수지</th>
                <th style={th}>반납지</th>
                <th style={th}>인수일시</th>
                <th style={th}>반납일시</th>
                <th style={th}>운전자</th>
                <th style={{ ...th, textAlign: 'right' }}>총액</th>
                <th style={th}></th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} style={{ borderTop: '1px solid var(--border)' }}>
                  <td style={td}>{r.rental_company || '-'}</td>
                  <td style={td}>{r.car_model || '-'}</td>
                  <td style={td}>{r.pickup_location || '-'}</td>
                  <td style={td}>{r.return_location || '-'}</td>
                  <td style={td}>{fmtDt(r.pickup_at)}</td>
                  <td style={td}>{fmtDt(r.return_at)}</td>
                  <td style={td}>{r.driver_name || '-'}</td>
                  <td style={{ ...td, textAlign: 'right', fontWeight: 600 }}>{fmt(r.total_cost)}</td>
                  <td style={{ ...td, whiteSpace: 'nowrap' }}>
                    <button onClick={() => setModalRow(r)} style={editBtn}>수정</button>{' '}
                    <button onClick={() => handleDelete(r)} style={delBtn}>삭제</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {modalRow !== undefined && (
        <CarModal travelCode={travelCode} row={modalRow}
          onClose={() => setModalRow(undefined)}
          onSaved={() => onChanged && onChanged()} />
      )}
    </div>
  );
}

function Info({ label, value }) {
  return (
    <div style={mobileInfoItem}>
      <span style={mobileInfoLabel}>{label}</span>
      <span style={mobileInfoValue}>{value}</span>
    </div>
  );
}

const th = { padding: '8px 10px', textAlign: 'left', fontWeight: 600, fontSize: 11 };
const td = { padding: '6px 10px', color: 'var(--text)' };
const emptyStyle = { padding: 16, color: 'var(--text-muted)', textAlign: 'center' };
const addBtn  = { padding: '4px 12px', background: 'var(--accent-700, #7c3aed)', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 11, fontWeight: 600 };
const editBtn = { padding: '2px 8px', background: 'transparent', color: 'var(--accent-300, #a78bfa)', border: '1px solid var(--accent-700, #7c3aed)', borderRadius: 4, cursor: 'pointer', fontSize: 10 };
const delBtn  = { padding: '2px 8px', background: 'transparent', color: '#dc2626', border: '1px solid #dc2626', borderRadius: 4, cursor: 'pointer', fontSize: 10 };
